module.exports = __webpack_public_path__ + "img/banner-s1.a118eb86.png";